var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Show blogs")]),_c('ul',_vm._l((_vm.records),function(record){return _c('li',[_c('h2',[_vm._v(_vm._s(record.title))]),_c('article',[_vm._v(_vm._s(record.body))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }